import Button from '@jetbrains/ring-ui/components/button/button'
import classNames from 'classnames'
import {memo} from 'react'

import {stringifyId} from '../../../../../../../types'
import {resolveRelative} from '../../../../../../../utils/url'

import type {Props} from './DownloadTestsButton.types'
import {getFilename} from './DownloadTestsButton.utils'

import styles from './DownloadTestsButton.css'

function DownloadTestsButton({className, buildId, projectName, buildTypeName, buildNumber}: Props) {
  return buildTypeName != null && buildNumber != null ? (
    <Button
      href={resolveRelative(
        `/get/tests/buildId/${stringifyId(buildId)}/${getFilename(
          projectName,
          buildTypeName,
          buildNumber,
        )}`,
      )}
      title="Download tests in CSV"
      className={classNames(className, styles.button)}
    >
      {'Download'}
    </Button>
  ) : null
}

export default memo<Props>(DownloadTestsButton)
